import React from 'react'
import { useIncomeExpenditureAuditMutation,useIncomeExpenditureCancelAuditMutation} from '../../store/ReactWebSiteApi';
import { Space, App } from 'antd';
function BalanceAudit(props) {
    const { message } = App.useApp();
    const [submitAudit] = useIncomeExpenditureAuditMutation()
    const [submitAuditCancle] = useIncomeExpenditureCancelAuditMutation()
    return (
        <Space>
            {
                (!props.eie_audit1_ctime && !props.eie_audit2_ctime  && props.eie_state==='2' && !localStorage.getItem('ess_menu_id').includes('93'))&& <a 
                onClick={() => {
                    // if(props.eie_type_id==='1' || props.eie_type_id==='2'){
                    //     Modal.info({
                    //         title: '团队收入和团队支出请在团队台账里审核！',
                    //         content: '',
                    //         onOk() {},
                    //       });
                    //     return false
                    // }      
                    submitAudit({
                        eie_id:props.eie_id,
                        rankNum:1,
                        uid:localStorage.getItem('eu_id'),
                        uname:localStorage.getItem('eu_name'),                                
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.info('1级审核成功！');
                        }
                        if (res.data.Status === "fail") {
                            message.error('1级审核失败！'+res.data.Message)
                        }})
                }}
                key='audit1'
            >1级审核</a>}
            {(props.eie_audit1_ctime && !props.eie_audit2_ctime && props.eie_state==='2' && !localStorage.getItem('ess_menu_id').includes('93'))&& <a 
                key='cancel1'
                onClick={() => {
                    // if(props.eie_type_id==='1' || props.eie_type_id==='2'){
                    //     Modal.info({
                    //         title: '团队收入和团队支出请在团队台账里取消审核！',
                    //         content: '',
                    //         onOk() {},
                    //       });
                    //     return false
                    // }   
                    submitAuditCancle({
                        eie_id:props.eie_id,
                        rankNum:1,                                                                
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.info('取消1级审核成功！');
                        }
                        if (res.data.Status === "fail") {
                            message.error('取消1级审核失败！'+res.data.Message)
                        }})
                }}>取消1级审核</a>}
            {(props.eie_audit1_ctime && !props.eie_audit2_ctime && props.eie_state==='2'&& !localStorage.getItem('ess_menu_id').includes('94'))&& <a 
                key='audit1'
                onClick={() => {
                    // if(props.eie_type_id==='1' || props.eie_type_id==='2'){
                    //     Modal.info({
                    //         title: '团队收入和团队支出请在团队台账里取消复核！',
                    //         content: '',
                    //         onOk() {},
                    //       });
                    //     return false
                    // }   
                    submitAudit({
                        eie_id:props.eie_id,
                        rankNum:2,
                        uid:localStorage.getItem('eu_id'),
                        uname:localStorage.getItem('eu_name'),                                
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.info('2级审核成功！');
                        }
                        if (res.data.Status === "fail") {
                            message.error('2级审核失败！'+res.data.Message)
                        }})
                }}>2级审核</a>}
            {(props.eie_audit2_ctime && !props.eie_audit3_ctime && !localStorage.getItem('ess_menu_id').includes('94')) && <a
                                            key='cancel2' 
                                            onClick={() => {
                                                // if(props.eie_type_id==='1' || props.eie_type_id==='2'){
                                                //     Modal.info({
                                                //         title: '团队收入和团队支出请在团队台账里取消复核！',
                                                //         content: '',
                                                //         onOk() {},
                                                //       });
                                                //     return false
                                                // }   
                                                submitAuditCancle({
                                                    eie_id:props.eie_id,
                                                    rankNum:2,                                                                
                                                }).then((res) => {
                                                    // console.log(res);
                                                    if (res.data.Status === 'success') {
                                                        message.info('取消2级审核成功！');
                                                    }
                                                    if (res.data.Status === "fail") {
                                                        message.error('取消2级审核失败！'+res.data.Message)
                                                    }})
                                            }}>取消2级审核</a>}
            {(props.eie_audit2_ctime && !props.eie_audit3_ctime && props.eie_state==='2'&& !localStorage.getItem('ess_menu_id').includes('94'))&& <a 
                key='audit3'
                onClick={() => {
                    // if(props.eie_type_id==='1' || props.eie_type_id==='2'){
                    //     Modal.info({
                    //         title: '团队收入和团队支出请在团队台账里取消复核！',
                    //         content: '',
                    //         onOk() {},
                    //       });
                    //     return false
                    // }   
                    submitAudit({
                        eie_id:props.eie_id,
                        rankNum:3,
                        uid:localStorage.getItem('eu_id'),
                        uname:localStorage.getItem('eu_name'),                                
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.info('3级审核成功！');
                        }
                        if (res.data.Status === "fail") {
                            message.error('3级审核失败！'+res.data.Message)
                        }})
                }}>3级审核</a>}
                {(props.eie_audit3_ctime && !props.eie_audit4_ctime && !localStorage.getItem('ess_menu_id').includes('94')) && <a
                                            key='cancel3' 
                                            onClick={() => {
                                                // if(props.eie_type_id==='1' || props.eie_type_id==='2'){
                                                //     Modal.info({
                                                //         title: '团队收入和团队支出请在团队台账里取消复核！',
                                                //         content: '',
                                                //         onOk() {},
                                                //       });
                                                //     return false
                                                // }   
                                                submitAuditCancle({
                                                    eie_id:props.eie_id,
                                                    rankNum:3,                                                                
                                                }).then((res) => {
                                                    // console.log(res);
                                                    if (res.data.Status === 'success') {
                                                        message.info('取消3级审核成功！');
                                                    }
                                                    if (res.data.Status === "fail") {
                                                        message.error('取消3级审核失败！'+res.data.Message)
                                                    }})
                                            }}>取消3级审核</a>}
                {(props.eie_audit3_ctime && !props.eie_audit4_ctime && props.eie_state==='2'&& !localStorage.getItem('ess_menu_id').includes('94'))&& <a 
                    key='audit4'
                    onClick={() => {
                        // if(props.eie_type_id==='1' || props.eie_type_id==='2'){
                        //     Modal.info({
                        //         title: '团队收入和团队支出请在团队台账里取消复核！',
                        //         content: '',
                        //         onOk() {},
                        //     });
                        //     return false
                        // }   
                        submitAudit({
                            eie_id:props.eie_id,
                            rankNum:4,
                            uid:localStorage.getItem('eu_id'),
                            uname:localStorage.getItem('eu_name'),                                
                        }).then((res) => {
                            // console.log(res);
                            if (res.data.Status === 'success') {
                                message.info('4级审核成功！');
                            }
                            if (res.data.Status === "fail") {
                                message.error('4级审核失败！'+res.data.Message)
                            }})
                    }}>4级审核</a>}
                 {(props.eie_audit4_ctime  && !localStorage.getItem('ess_menu_id').includes('94')) && <a
                                            key='cancel4' 
                                            onClick={() => {
                                                // if(props.eie_type_id==='1' || props.eie_type_id==='2'){
                                                //     Modal.info({
                                                //         title: '团队收入和团队支出请在团队台账里取消复核！',
                                                //         content: '',
                                                //         onOk() {},
                                                //       });
                                                //     return false
                                                // }   
                                                submitAuditCancle({
                                                    eie_id:props.eie_id,
                                                    rankNum:4,                                                                
                                                }).then((res) => {
                                                    // console.log(res);
                                                    if (res.data.Status === 'success') {
                                                        message.info('取消4级审核成功！');
                                                    }
                                                    if (res.data.Status === "fail") {
                                                        message.error('取消4级审核失败！'+res.data.Message)
                                                    }})
                                            }}>取消4级审核</a>}
        </Space>
    )
}

export default BalanceAudit